import React from 'react';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import { Redirect } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<ContextualAnalyticsData sourceType={SCREEN} sourceName="projectsTrashRedirect">
		<Redirect to="/jira/settings/projects/trash" />
		<FireScreenAnalytics />
	</ContextualAnalyticsData>
);
